import React, {useEffect, useState, useRef, useContext} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import {IFormatPlatform, IProps} from './types';
import * as S from './styles';
import { default as D } from '@assets/themes/dimensions';
import { FilterIcon } from '@assets/icons/filterIcon';
import FilterCheck from '@components/Filter';
import Search from '../Search';
import { TemplatesContext } from '@utils/DOIgnition/TemplatesContext';
import {IDSConfig, IBrandDefinition,IPlatform, IFormat} from '@state/dsconfig/types';
import { otherElementHasColor } from '@utils/colors';

const Filter:React.FC<IProps> = (props) => {
  const{ location, filtering, hasDesigns, searching} = useContext(TemplatesContext);
  const [showMenu, setShowMenu]= useState(false)
  const [plataforms, setPlataform]= useState([] as any)
  const [plataformsObj, setPlataformsObj]= useState<IPlatform[]>([])
  const [formats, setFormats]= useState<IFormatPlatform[]>([])
  const [status, setStatus]= useState(["Unpublished", "Published", "Disabled"])
  const dispatch = useDispatch();
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const componentRef = useRef(null);
  const componentRefMenu = useRef(null);

  const handleClick = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if (!ref.contains(e.target) && e.target.id !== 'filterButton' && e.target.id!=='filterIcon'){
          setShowMenu(false);
        }
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [])

  useEffect(() => {
    if(dsConfig){
      let plataforms: any=[]
      let plataformsObj:IPlatform[] = []
      dsConfig.designTypes.forEach((item:any)=>{
          item.platforms.forEach((plataform:any)=>{
            if(plataforms.includes('Google') && plataform.name == 'Google'){
              plataformsObj.push(plataform);
            }
            else {
            plataforms.push(plataform.name)
            plataformsObj.push(plataform);
            }
          })
      })
      setPlataformsObj(plataformsObj);
      setPlataform(plataforms)      
    }
    
  }, [dsConfig])

  useEffect(()=>{

    refreshFormats();

  },[props.filters])



  const refreshFormats = ()=>{
    let newformats:IFormatPlatform[] = formats;
    plataformsObj.map((item:IPlatform,index:number)=>{      
      if (!props.filters["platform"].includes(item.name))
      {
          newformats = newformats.filter(f=>f.platform!= item.name);
      }            
    })
    setFormats(newformats)            
  }

  const handleClickBtnFilter = ()=>setShowMenu(!showMenu);
  const handleChangeFilters = (value:any, type:string, add:boolean)=>{
    if (type=="platform")
    {
      let newformats:IFormatPlatform[] = [];
        plataformsObj.map((item:IPlatform,index:number)=>{
          if (item.name === value)
          {
            if (add)
            {
              newformats= formats;
              item.formats.map((format:IFormat, index:number)=>{
                let formatPlatform :IFormatPlatform ={
                  platform: item.name,
                  name: format.name,
                  width: format.width,
                  height: format.height
                }
                newformats.push(formatPlatform);
              })
            }              
            else
            {
              newformats = formats.filter(f=>f.platform!= item.name);
            }

          }
        })            
      setFormats(newformats)


      
    }
    props.onChange(value, type, add)
  };

  let colWidth='0 0 25%';
  let width=!props.openMenu ? `calc(74vw - ${D.VERTICAL_MENU_WIDTH + D.LOGOUT_WIDTH}px)` : `calc(74vw - ${D.LOGOUT_WIDTH}px)`;
  
  if(location==='studio'){
    colWidth='0 0 33.33%';
    width=!props.openMenu ? `calc(54vw - ${D.VERTICAL_MENU_WIDTH + D.LOGOUT_WIDTH}px)` : `calc(54vw - ${D.LOGOUT_WIDTH}px)`;
  }

  let marginLeft = '';
  if (location==='studio' && !hasDesigns) marginLeft = 'auto';
  if (searching) marginLeft = '';

  return (
    <>
      <S.Root>
        <Search openMenu={props.openMenu} onSearchClick={props.onSearchClick} deteleItem={props.deteleItem}/>

        <S.FilterContainer>
            <S.ButtonFilter onClick={handleClickBtnFilter} id="filterButton">
                <FilterIcon style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: "5px", marginRight: "14px"}}/>
                Filter
            </S.ButtonFilter>
        </S.FilterContainer>
      </S.Root >
      {dsConfig&&
        <S.MenuFilter ref={componentRef} margin={marginLeft} style={{
          display: showMenu?'block':'none',
          width: width}}>
          <S.Container >
            <S.List colWidth={colWidth}>
              <S.Label>OEM</S.Label>
              { dsConfig.brands.sort((a, b) => {
                  var textA = a.name.toUpperCase();
                  var textB = b.name.toUpperCase();
                  return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }).map((text:IBrandDefinition, index:number) => 
                    <FilterCheck 
                    key={`oem${index}`}
                    label={text.name} 
                    type="oem" 
                    onChange={handleChangeFilters}
                    checked={props.filters['oem'].includes(text.name)}/>
              )}
            </S.List>
            <S.List colWidth={colWidth}>
              <S.Label>Ad Platform</S.Label>
              {plataforms.sort().map((text:string, index:number) => 
                  <FilterCheck 
                  key={`platf${index}`}
                  label={text} 
                  type="platform" onChange={handleChangeFilters}
                  checked={props.filters['platform'].includes(text)}/>
              )}
              {
                formats && formats.length>0 &&
                <>
                <S.Label>Ad Format</S.Label>
                {formats.sort().map((item:IFormat, index:number) => 
                  <FilterCheck 
                  key={`format${index}`}
                  label={`${item.width}x${item.height} - ${item.name}`} 
                  value={item.name} 
                  type="format" onChange={handleChangeFilters}
                  checked={props.filters && props.filters['format'].includes(item.name)}/>
                )}
                </>
              }
            </S.List>
            <S.List colWidth={colWidth}>
              <S.Label>Offer Type</S.Label>
              {dsConfig.offerTypes.sort().map((text:string, index:number) => 
                  <FilterCheck 
                  key={`of${index}`}
                  label={text} 
                  type="offerType" 
                  onChange={handleChangeFilters}
                  checked={props.filters['offerType'].includes(text)}/>
              )}
            </S.List>
            {location ==='templates' &&
                <S.List colWidth={colWidth}>
                  <S.Label>Status</S.Label>
                  {status.map((text:string, index:number) => 
                      <FilterCheck 
                      key={`status${index}`}
                      label={text} 
                      type="templateStatus" 
                      onChange={handleChangeFilters}
                      checked={props.filters['templateStatus'].includes(text)}/>
                  )}
                </S.List>
            }
          </S.Container>
        </S.MenuFilter>
      }
    </>
  );
}

export default Filter;